import React from 'react';
import { Button, Modal, ModalSize } from '@/components/shared';
import { TranslationsWebsite } from '@/generated/data.schemas';
import styles from './ActionModal.module.scss';

interface ActionModalProps {
	onClose?: () => void;
	onCancel: () => void;
	onSubmit: () => void;
	headline?: string;
	message?: string;
	cancelText?: string;
	submitText?: string;
	size?: ModalSize;
	translations?: TranslationsWebsite;
}

export const ActionModal: React.FunctionComponent<ActionModalProps> = ({
	translations,
	onClose,
	onCancel,
	onSubmit,
	headline,
	message,
	cancelText,
	submitText,
	size,
}) => {
	return (
		<Modal open size={size} onClose={onClose || onCancel}>
			<div className={styles.wrapper}>
				<h5>{headline}</h5>
				<p>{message}</p>
				<div className={styles.actionWrapper}>
					<Button variant={'ghost'} isFullWidth onClick={onCancel}>
						{cancelText || translations?.shared.cancel}
					</Button>
					<Button variant={'primary'} isFullWidth onClick={onSubmit}>
						{submitText || translations?.shared.continue}
					</Button>
				</div>
			</div>
		</Modal>
	);
};
